<template>
  <div class="social-networks-view">
    <h3
      v-html="$t('common.following_label')"
      v-if="Object.keys(instance.socialmedia).length > 0"
    />
    <div class="buttons-social-networks">
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.facebook"
        v-if="instance.socialmedia.facebook && instance.socialmedia.facebook.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-facebook</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.instagram"
        v-if="instance.socialmedia.instagram && instance.socialmedia.instagram.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-instagram</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.twitter"
        v-if="instance.socialmedia.twitter &&  instance.socialmedia.twitter.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-twitter</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.twitch"
        v-if="instance.socialmedia.twitch && instance.socialmedia.twitch.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-twitch</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.youtube"
        v-if="instance.socialmedia.youtube && instance.socialmedia.youtube.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-youtube</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.whatsapp"
        v-if="instance.socialmedia.whatsapp && instance.socialmedia.whatsapp.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-whatsapp</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.webpage"
        v-if="instance.socialmedia.webpage && instance.socialmedia.webpage.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-light fa-globe</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.spotify"
        v-if="instance.socialmedia.spotify && instance.socialmedia.spotify.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-spotify</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.tiktok"
        v-if="instance.socialmedia.tiktok && instance.socialmedia.tiktok.toString().length > 0"
        target="_blank"
      >
        <v-icon large class="linktree">fa-brands fa-tiktok</v-icon>
      </v-btn>
      <v-btn
        dark fab icon small
        :href="instance.socialmedia.tripadvisor"
        v-if="instance.socialmedia.tripadvisor && instance.socialmedia.tripadvisor.toString().length > 0"
        target="_blank"
      >
        <v-avatar size="50">
          <v-img contain src="@/assets/whiteTripAdvisor.png" alt="alt" />
        </v-avatar>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialNetworks",
  props: [ "instance" ]
}
</script>

<style lang="scss">
.social-networks-view {
  text-align: center;
  padding: 20px;
  h3 {
    margin-bottom: 1rem !important;
    color: #ffffff !important
  }
  .buttons-social-networks {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    max-width: 80%;
    margin: auto;
    a {
      margin: 0.2rem;
    }
  }
}
</style>